'use client';
import { ChangeEvent, FC, useCallback, useState } from 'react';

interface Props {
    onOptionClick: (label: string) => void;
    options: { label: string }[];
}

const FeaturedProductSelect: FC<Props> = ({ onOptionClick, options }) => {
    const [selected, setSelected] = useState(options[0].label);

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
            setSelected(e.target.value);
            onOptionClick(e.target.value);
        },
        [onOptionClick],
    );

    return (
        <div className="tw-w-full tw-px-[5px] tw-mt-[10px]  sm:tw-mt-[15px] md:tw-hidden tw-border-blue-500">
            <select
                name="products"
                id="productTabMob"
                className="tw-w-full tw-h-auto tw-p-[12px] tw-font-gotham-bold tw-text-[16px]
                tw-text-[#3e4247]
                tw-bg-sky-50
                tw-rounded-md
                tw-border-2
                tw-border-[#007dba]
                tw-pr-10 !focus:tw-shadow-blue-300 focus:tw-outline-blue-200"
                value={selected}
                onChange={handleChange}
            >
                {options.map((option) => (
                    <option value={option.label} key={option.label}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FeaturedProductSelect;
